import React from 'react';
import { useEffect, useRef } from 'react';

import './index.scss';

type WrapperContext = {
  childRef?: React.RefObject<HTMLDivElement>;
  buttonsRef?: React.RefObject<HTMLDivElement>;
};

const ButtonsWrapperContext = React.createContext<WrapperContext>({});

export const useButtonsWrapperContext = () => React.useContext(ButtonsWrapperContext);

export const ButtonsWrapper = ({ children }: React.PropsWithChildren<React.ReactNode>) => {
  const [childDimensions, setChildDimensions] = React.useState({ width: 100, height: 0 });
  const childRef = useRef<HTMLDivElement>(null);
  const buttonsRef = useRef<HTMLDivElement>(null);

  function resize() {
    setChildDimensions({
      width: childRef.current?.clientWidth || 0,
      height: childRef.current?.clientHeight || 0,
    });
  }
  useEffect(() => {
    window.addEventListener('resize', resize);

    return () => {
      window.removeEventListener('resize', resize);
    };
  }, []);

  useEffect(() => {
    resize();
  }, []);

  return (
    <ButtonsWrapperContext.Provider value={{ childRef, buttonsRef }}>
      {children}
      <div className="buttons-wrapper" style={{ maxWidth: childDimensions.width }}>
        <div className="buttons-wrapper__action" ref={buttonsRef} />
      </div>
    </ButtonsWrapperContext.Provider>
  );
};
